// Client for PlacesController (Google Places behind our own endpoints), shared by
// the location field. Details are cached per place for the page's lifetime.
const AUTOCOMPLETE_URL = '/places/autocomplete';
const DETAILS_URL = '/places/details';

const getJson = async (path, params, signal) => {
  const url = new URL(path, window.location.origin);
  Object.entries(params).forEach(([key, value]) => url.searchParams.set(key, value));

  const response = await fetch(url, { headers: { Accept: 'application/json' }, signal });
  if (!response.ok) throw new Error(response.statusText);

  return response.json();
};

const details = new Map();

export const fetchPredictions = async (input, types, signal) => {
  const { predictions } = await getJson(AUTOCOMPLETE_URL, { input, types }, signal);
  return predictions || [];
};

export const fetchDetails = async placeId => {
  if (details.has(placeId)) return details.get(placeId);

  const { result } = await getJson(DETAILS_URL, { place_id: placeId });
  if (result) details.set(placeId, result);
  return result || null;
};

// Mirrors LocationInput.handleChange: without a country nothing is kept, and
// the city and coordinates only come along for a locality with geometry.
export const locationFrom = place => {
  const components = place.address_components;
  const country = components.find(component => component.types.includes('country'));
  const city = components.find(component => component.types.includes('locality'));
  const location = {};
  if (!country) return location;

  location.country_code = country.short_name;
  location.google_place_id = place.place_id;

  if (place.geometry && city) {
    location.city = city.long_name;
    location.latitude = String(place.geometry.location.lat);
    location.longitude = String(place.geometry.location.lng);
  }

  return location;
};
